module.exports = __webpack_public_path__ + "assets/droplet-text.322d20e0.svg";